import { render, staticRenderFns } from "./orderInfoModal.vue?vue&type=template&id=bf135942"
import script from "./orderInfoModal.vue?vue&type=script&lang=js"
export * from "./orderInfoModal.vue?vue&type=script&lang=js"
import style0 from "./orderInfoModal.vue?vue&type=style&index=0&id=bf135942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports